import styled from 'styled-components';
const percentageSize = 1.3;

export const AjudaContainer = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  display: ${({ ajudaOpen }) => (ajudaOpen ? 'block' : 'none')};
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
`;
export const FletxaMenu = styled.div`
  position: absolute;

  .fletxaLlarga {
    display: block;
  }
  .fletxaMini {
    display: none;
  }
  top: 220px;
  transform: scale(0.6) rotate(270deg);
  left: -320px;

  @media screen and (max-height: 660px) {
    transform: scale(0.4) rotate(270deg);
    top: 150px;
  }
`;
export const Menu = styled.div`
  position: absolute;
  color: white;
  top: 450px;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  left: 10px;
  @media screen and (max-height: 660px) {
    top: 310px;
  }
`;

export const FletxaLlegenda = styled.div`
  position: absolute;
  top: 70px;
  transform: scale(0.6);
  left: 15px;
  .fletxa {
    display: none;
  }
  @media screen and (max-width: 768px) {
    transform: none;
    .fletxa {
      display: block;
    }
    .fletxaMini {
      display: none;
    }
    top: 150px;
    left: 30px;
  }
`;
export const Llegenda = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  opacity: 100%;
  color: white;
  top: 180px;
  left: 25px;
  @media screen and (max-width: 768px) {
    top: 280px;
  }
`;

export const FletxaCurvaDiv = styled.div`
  .curva {
    width: 160px;
  }
  position: absolute;
  left: 53%;
  top: 10px;
  @media screen and (max-width: 1400px) {
    left: 68%;
  }
  @media screen and (max-width: 1280px) {
    left: auto;
    right: 90px;
  }

  @media screen and (max-width: 768px) {
    top: 50px;
    left: auto;
    right: 70px;
  }
`;
export const FletxaCercador = styled.div`
  position: absolute;
  top: 50px;
  left: 50%;

  @media screen and (max-width: 1400px) {
    top: 50px;
    left: 65%;
  }
  @media screen and (max-width: 1280px) {
    left: auto;
    right: 250px;
  }

  @media screen and (max-width: 768px) {
    top: 80px;
    left: auto;
    right: 250px;
  }
`;
export const Cercador = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  top: 180px;
  left: 50%;
  @media screen and (max-width: 1400px) {
    left: 65%;
  }
  @media screen and (max-width: 1280px) {
    left: auto;
    right: 200px;
  }

  @media screen and (max-width: 768px) {
    top: 210px;
    left: auto;
    right: 200px;
  }
`;

export const FletxaCataleg = styled.div`
  position: absolute;
  bottom: -27px;
  transform: rotate(270deg) scale(0.6);
  left: 80px;

  @media screen and (max-width: 600px) {
    transform: rotate(180deg) scale(0.6);
    left: 20px;
    top: auto;
    bottom: 30px;
  }
`;

export const Cataleg = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  bottom: 25px;
  left: 150px;
  @media screen and (max-width: 600px) {
    left: 30px;
    top: auto;
    bottom: 140px;
  }
`;

export const FletxaFons = styled.div`
  position: absolute;
  bottom: 0px;
  transform: rotate(90deg) scale(0.6);
  right: 80px;
  @media screen and (max-width: 930px) {
    transform: rotate(180deg) scale(0.6);
    /* bottom: 75px; */
    bottom: ${({ fav }) => (fav ? '140px' : '75px')};
    right: 15px;
  }
`;

export const Fons = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  bottom: 45px;
  right: 150px;
  @media screen and (max-width: 930px) {
    /* bottom: 190px; */
    bottom: ${({ fav }) => (fav ? '250px' : '190px')};
    right: 20px;
  }
  @media screen and (max-height: 775px) and (max-width: 768px) {
    bottom: ${({ fav }) => (fav ? '250px' : '190px')};
    right: 20px;
  }
`;
export const FletxaFav = styled.div`
  position: absolute;
  transform: rotate(90deg) scale(0.6);
  bottom: 75px;
  right: 80px;
  @media screen and (max-width: 930px) {
    display: none;
  }
`;

export const Fav = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  bottom: 125px;
  right: 145px;

  @media screen and (max-width: 930px) {
    display: none;
  }
`;

export const FletxaNavbar = styled.div`
  position: absolute;
  top: 180px;
  right: -315px;
  transform: rotate(270deg) scaleX(0.5) scaleY(0.5);

  @media screen and (max-width: 768px) {
    transform: rotate(270deg) scale(0.4);
    top: 140px;
  }
  @media screen and (max-height: 660px) {
    transform: rotate(270deg) scale(0.35);
    top: 120px;
  }
`;

export const Navbar = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  top: 370px;
  right: 10px;
  @media screen and (max-width: 768px) {
    top: 300px;
  }
  @media screen and (max-height: 660px) {
    top: 250px;
  }
`;
export const FletxaMesura = styled.div`
  position: absolute;
  top: 75px;
  transform: scale(0.6);
  right: 25px;
  .fletxaLlarga {
    display: none;
  }

  @media screen and (max-width: 768px) {
    top: 115px;
  }
  @media screen and (max-height: 660px) {
    transform: scale(0.4);
    top: 100px;
  }
`;

export const Mesura = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  top: 190px;
  right: 35px;
  @media screen and (max-width: 768px) {
    top: 230px;
  }
  @media screen and (max-height: 660px) {
    top: 200px;
  }
`;

export const Scale = styled.div`
  position: absolute;
  background-color: rgba(51, 51, 51, 0.85);
  padding: 5px;
  color: white;
  left: 50%;
  bottom: 125px;
`;
export const ScaleFletxa = styled.div`
  position: absolute;
  left: 50%;
  bottom: 15px;
  transform: rotate(180deg) scale(0.6);
`;
